import type { FC } from 'react';
import { Pagination } from '@components/Table';

import { PAGE_SIZE_OPTIONS } from '../../shared/constants';

export interface TableFooterProps {
  onPageChange: (pageIndex: number) => void;
  onPageSizeChange: (pageSize: number) => void;
  pageIndex: number;
  pageSize: number;
  totalResults: number;
  totalResultsForDisplay: number;
}

export const TableFooter: FC<TableFooterProps> = ({
  onPageChange,
  onPageSizeChange,
  pageIndex,
  pageSize,
  totalResults,
  totalResultsForDisplay,
}) => {
  return (
    <div className="relative flex w-full flex-col items-start">
      <div className="h-px w-full shrink-0 bg-gray-200" />
      <div className="relative flex w-full items-center justify-between px-6 py-3">
        <p className="text-sm leading-5 font-normal text-gray-700">
          {totalResults > 0 ? (
            <>
              Showing <span className="font-medium">{1 + pageIndex * pageSize}</span> to{' '}
              <span className="font-medium">
                {(pageIndex + 1) * pageSize > totalResults ? totalResults : (pageIndex + 1) * pageSize}
              </span>{' '}
              of <span className="font-medium">{totalResultsForDisplay}</span>
            </>
          ) : (
            <span className="font-medium">0 results</span>
          )}
        </p>
        <Pagination
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
          pageIndex={pageIndex}
          pageSize={pageSize}
          pageSizeOptions={PAGE_SIZE_OPTIONS}
          totalResults={totalResults}
        />
      </div>
    </div>
  );
};
